import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const NewWindow18 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={18}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M15.25 15.25L6.5 15.25V16.75L15.5 16.75C16.1904 16.75 16.75 16.1904 16.75 15.5L16.75 2.5C16.75 1.80964 16.1904 1.25 15.5 1.25H2.5C1.80965 1.25 1.25 1.80964 1.25 2.5V12.5H2.75L2.75 5.75H15.25L15.25 15.25ZM2.75 2.75L2.75 4.25H4.25V2.75L2.75 2.75ZM5.75 2.75L15.25 2.75V4.25H5.75V2.75Z'
      fill='currentColor'
    />
    <path
      d='M8.18939 9.25L5 9.25V7.75H10.75L10.75 13.5L9.25 13.5V10.3107L3.03039 16.5303L1.96973 15.4697L8.18939 9.25Z'
      fill='currentColor'
    />
  </Svg>
);

NewWindow18.displayName = 'NewWindow18';
export default NewWindow18;
